import { Injectable, ApplicationRef } from '@angular/core';


import { MediaParserService } from './media-parser.service';
import { IMediaManager } from './media-manager';
import { WsService2 } from '../ws/ws.service';


import { LogService, Log } from '../log/log.service';

import { LayoutManagerService } from '../layout/layout-manager.service';
import { Http } from '@angular/http';
//import { WbService } from 'app/wb/wb.service';

/*declare var AdapterJS;
declare var RTCPeerConnection;
declare var RTCSessionDescription;
declare var attachMediaStream;
declare var RTCIceCandidate;*/
declare var $;
declare var navigator
declare var webrtcDetectedBrowser;

declare var webrtcDetectedVersion;
/*declare var LZString;*/
declare var window;
declare var getStats;
declare var RTCRtpSender;

export interface OnMedia{
	onMediaError(error);
	onMediaConnected(media);
	onMediaReconnected();
	onIncomingUpdated(who, connected);
	onMediaUpdated(who, media);
}
export interface OnTalking{
	onTalking(who, talks);
}
class MediaStat{
	outgoung
	public constructor(outgoing){
		
	}
}
class InMediaStat extends MediaStat{
	bytesReceived
	fractionLost
	packetsLost
	packetsReceived
	public constructor(bytesReceived, fractionLost, packetsLost, packetsReceived){
		super(false);
		this.bytesReceived = bytesReceived;
		this.fractionLost = fractionLost;
		this.packetsLost = packetsLost;
		this.packetsReceived = packetsReceived;
	}
}
class AudioInMediaStat extends InMediaStat{
	jitter
	public constructor(bytesReceived, fractionLost, packetsLost, packetsReceived, jitter){
		super(bytesReceived, fractionLost, packetsLost, packetsReceived);
		this.jitter = jitter
	}
}
class VideoInMediaStat extends InMediaStat{
	firCount
	framesDecoded
	nackCount
	pliCount
	qpSum
	framesDropped
	framesReceived
	public constructor(bytesReceived, tractionLost, packetsLost, packetsReceived, firCount, framesDecoded, nackCount, pliCount, qpSum){
		super(bytesReceived, tractionLost, packetsLost, packetsReceived);
		this.firCount = firCount;
		this.framesDecoded = framesDecoded;
		this.nackCount =  nackCount;
		this.pliCount = pliCount;
		this.qpSum = qpSum;
	}
}

class UserStat{
	audioIn: MediaStat
	videoIn: MediaStat
	audioOut: MediaStat
	videoOut: MediaStat
	localIp
	localPort
	localProto;
	localType;
	remoteIp;
	remotePort;
	remoteProto;
	remoteType;
	hash;
	bytesReceived; availableIncomingBitrate; availableOutgoingBitrate; bytesSent; currentRoundTripTime; totalRoundTripTime;
	
}
class OutMediaStat extends MediaStat{
	bytesSent
	packetsSent
	ssrc
	trackId
	public constructor(bytesSent, packetsSent, ssrc, trackId){
		super(true);
	
	}
}
class AudioOutMediaStat extends OutMediaStat{
	audioLevel
	totalAudioEnergy
	totalSamplesDuration
	public constructor(bytesSent, packetsSent, ssrc, trackId){
		super(bytesSent, packetsSent, ssrc, trackId);
	}
}
class VideoOutMediaStat extends OutMediaStat{
	firCount
	framesEncoded
	nackCount
	pliCount
	qpSum
	framesSent
	frameHeight;
	frameWidth;
	public constructor(bytesSent, packetsSent, ssrc, trackId, firCount, framesEncoded, nackCount, pliCount, qpSum){
		super(bytesSent, packetsSent, ssrc, trackId);
		
	}
}
@Injectable()
export class MediaManagerService implements IMediaManager {
	constructor(private http: Http, private appRef: ApplicationRef, /*private wbService: WbService, */private mediaParser: MediaParserService, private ws: WsService2, private log: LogService) {
		mediaParser.setManager(this);
		this.registerForOnPeerTalking();
	}
	static MEDIA_SHARESCREEN = "sharescreen";
	static MEDIA_SHARESCREEN_NONE = "sharescreennone";
	streams = {};
	onTalkingCallbacks: OnTalking[]=[];
	registerOnTalkingCallbacks(cb: OnTalking){
		for (let c of this.onTalkingCallbacks){
			if (c == cb)return;
		}
		this.onTalkingCallbacks.push(cb);
	}
	onMediaCallbacks:OnMedia[]= [];
	registerOnMediaCallback(cb: OnMedia){
		for (let c of this.onMediaCallbacks){
			if (c == cb)return;
		}
		this.onMediaCallbacks.push(cb);

	}

  layoutManager: LayoutManagerService;
  setLayoutManager(m){
      this.layoutManager = m;
  }
	changeMedia(callee, media) {
		this.mediaParser.requestChangeMedia(callee, media);
	}
	requestShareScreen() {
		this.changeMedia(this.ws.getMe(), MediaManagerService.MEDIA_SHARESCREEN);

	}
	public getLocalVideoAudio(video, audio, sfn, efn) {
		navigator.mediaDevices.getUserMedia({
			audio: audio,
			video: video
		  }).then(sfn).catch(efn);
	}

	private getAudio(media) {
		return media == 'both' || media == 'audio' || media=='audio-snapshots';
	}
	private getVideo(media) {
		return media == 'both' || media == 'video';
	}
	private getConfiguration() {
		var configuration = {
			iceServers: [

				{ url: 'stun:stun.l.google.com:19302' },
				{ url: 'stun:stun1.l.google.com:19302' },
				{ url: 'stun:stun2.l.google.com:19302' },
				{ url: 'stun:stun3.l.google.com:19302' },
				{ url: 'stun:stun4.l.google.com:19302' },
				{
					'url': 'turn:turn.daskal.eu:443',
					'credential': 'svilen',
					'username': 'svilen'
				}
			]
		};
		return configuration;
	}
	private attachMediaStream(stream, callee) {
		
		var element = $("#video-" + callee)[0];
		if (element){
			element.srcObject = stream;
		}
		//		element = attachMediaStream(element, stream);
		console.log("Attaching media stream ", element);
		
}
	peers = {};
	private sendPcDown(callee, media) {
		this.mediaParser.sendPcDown(callee, media);
	}
	private sendCandidate(callee, media, candidate) {
		this.mediaParser.sendCandidate(callee, media, candidate);
	}
	private sendSdp(sdp, outgoiong, callee, media) {
		this.mediaParser.sendHandshake(sdp, outgoiong, callee, media);
	}
	mediaHashes = {}
	sharing = false;
	callees = {}
	destroyPc(pc){
	pc.oniceconnectionstatechange = null;
	pc.close();
	}
	private createPeer(callee, video, audio, stream, outgoing, media) {

		var configuration:any = this.getConfiguration();
		let self = this;
		var oldpc = this.peers[this.getMediaHash(callee, media)];
		if (oldpc) {
			console.log("oldpc exists, maybe watcher is active..");
			try {
				self.destroyPc(oldpc);

			} catch (err) { }
			console.log("oldpc cleared");
			delete self.peers[self.getMediaHash(callee, media)];
			self.stopOldMedias(callee, media);
		}
		var pc:any = new RTCPeerConnection(configuration);
		if (!this.mediaHashes[callee]) {
			this.mediaHashes[callee] = [];
		}
		this.mediaHashes[callee].push(this.getMediaHash(callee, media));
		this.callees[this.getMediaHash(callee, media)] = callee;
		pc.onicecandidate = function (e) {
			console.log("Got in onice")
			if (e.candidate) {
				var c = e.candidate
				var candidate = { "candidate": c.candidate, sdpMid: c.sdpMid, sdpMLineIndex: c.sdpMLineIndex }
				console.log("Got candidate ", candidate);
				self.sendCandidate(callee, media, candidate);
			}
		};
		pc.oniceconnectionstatechange = function (e) {
			console.log("Got change in signalling state for ", e);
			console.log(pc.iceConnectionState);
			if (pc.iceConnectionState == "closed"||pc.iceConnectionState == "disconnected") {
			
				self.pcIsDown(callee, media);
				
			}
		}
		var offerVideo;
		var offerAudio;
		if (outgoing) {
			//pc.addStream(stream);
			stream.getTracks().forEach(track => pc.addTrack(track, stream));
			if (media != MediaManagerService.MEDIA_SHARESCREEN) {
				self.attachMediaStream(stream, callee);
			}
			video = audio = false;
		} else {
			pc.ontrack = function (e) {
				var stream = e.streams[0];
				console.log("Got event on add stream")
				if (media != MediaManagerService.MEDIA_SHARESCREEN) {
					console.log("Stream is ",stream);
					self.attachMediaStream(stream, callee);
				} else {
					console.log("Media is " + media + " so will share screen")
					self.sharing = true;
					setTimeout(function () {
						self.attachMediaStream(stream, "sharing");
					}, 200);

				}
				/*if (e.stream.getVideoTracks() && e.stream.getVideoTracks().length > 0)
					e.stream.getVideoTracks()[0].onended = function () {
						console.log("Video of peer " + hash + " stopped");
					}*/
			}
		}
		this.peers[this.getMediaHash(callee, media)] = pc;
		

const offerOptions = {
	offerToReceiveAudio: audio?1:0,
	offerToReceiveVideo: video?1:0
  };
		pc.createOffer(offerOptions).then(function (desc) {
			pc.setLocalDescription(desc);
			self.sendSdp(desc.sdp, outgoing, callee, media)
		}, function (error) {
			console.error(error)
		});

	}
	pcIsDown(callee, media){
		this.stopOldMedias(callee, media);
		var self = this;
		var pc = this.peers[this.getMediaHash(callee, media)];
		if (pc){
		pc.oniceconnectionstatechange = function(){self.log.logMedia("There was a change in the state after pc is down")}
		delete  this.peers[this.getMediaHash(callee, media)];
		pc = null;
		
		this.sendPcDown(callee, media);
	}	
}
	private closePc(pc) {
		if (pc) {
			try {
				this.destroyPc(pc);
			
			} catch (err) {
				this.log.logMedia("Couldnt close pc with err ", err);
			}
		}
	}
	private closePeers(callee) {

		this.closePc(this.peers[this.getMediaHash(callee, "both")]);
		this.closePc(this.peers[this.getMediaHash(callee, "video")]);
		this.closePc(this.peers[this.getMediaHash(callee, "audio")]);
	}
	private closeShareScreenPeer() {

	}
snapshotsStream
	onRequestMedia(callee, media, outgoing) {
		this.log.logMedia("Got on request media "+media+" for outgoing "+outgoing)
		let audio = this.getAudio(media);
		let video = this.getVideo(media)
		let self = this;
		if (media == "none") {
			//	this.closePeers(callee);
			//	if (outgoing)
			//		this.stopOutgoingStream(this.streams[this.getMediaHash(callee, media)]);
			this.mediaParser.sendHandshake(null, outgoing, callee, media);
			return;
		}
		if (media == MediaManagerService.MEDIA_SHARESCREEN_NONE) {
			this.sharing = false;
			//this.closePc(this.peers[this.getMediaHash(callee, MediaManagerService.MEDIA_SHARESCREEN)]);
			this.mediaParser.sendHandshake(null, outgoing, callee, media);
			return;
		}
		if (outgoing) {
			switch (media) {
				case MediaManagerService.MEDIA_SHARESCREEN:
					if (this.sharingStream)
						this.createPeer(this.ws.getMe(), false, false, this.sharingStream, true, MediaManagerService.MEDIA_SHARESCREEN);
					break;
				case "none":

					break;
					case "audio-snapshots":
					//self.createPeer(callee, false, false, null, outgoing, media);
					//if (media == "audio-snapshots"){
							self.layoutManager.setSnapshotCanvas();
							self.getLocalVideoAudio(true, false, function(s){
						//		debugger
								self.attachMediaStream(s, callee);
								self.snapshotsStream = s;
								self.layoutManager.setSnapshotCanvas();
								self.mediaParser.sendHandshake(null, outgoing, callee, media);
							}, function(e){
								
							});
					//	}
						break;
				default:
				
					this.getLocalVideoAudio(video, audio, function (stream) {
						if (self.streams[self.getMediaHash(callee, media)]) {
							self.log.logMedia("Stream already exists... " + self.getMediaHash(callee, media));
							self.stopOutgoingStream(self.streams[self.getMediaHash(callee, media)]);
						}
						
						self.streams[self.getMediaHash(callee, media)] = stream;
						self.createPeer(callee, video, audio, stream, outgoing, media);
						/*if (media == "audio-snapshots"){
							self.layoutManager.setSnapshotCanvas();
							self.getLocalVideoAudio(true, false, function(s){
								self.attachMediaStream(s, callee);
								self.snapshotsStream = s;
								self.layoutManager.setSnapshotCanvas();
							}, function(e){
								
							});
						}*/
					}, function (error) {

					});
					break;
			}
		} else {
			if (media == MediaManagerService.MEDIA_SHARESCREEN) {
				video = true;
			}



			self.createPeer(callee, video, audio, null, outgoing, media);
		}
	}
	private getMediaHash(callee, media) {
		return callee + media;
	}
	onHandshake(callee, media, sdp) {
		var self = this;
		this.peers[this.getMediaHash(callee, media)].setRemoteDescription(new RTCSessionDescription({ sdp: sdp, type: 'answer' }), function () {
			self.log.logMedia("Setting remote description")
		}, function (error) {
			self.log.logMedia("Error while setting remote description ",error)
		});
	}
	onCandidate(callee, media, candidate) {
		var self = this;
		//if (candidate.candidate.indexOf("relay")==-1)return
		//console.log("GOT candidate relay"+candidate);
				this.peers[this.getMediaHash(callee, media)].addIceCandidate(new RTCIceCandidate(candidate),
			function () {
				self.log.logMedia("Added candidate");
				var iceLogged;
				try{
					iceLogged = JSON.stringify(candidate);
					self.log.log(iceLogged, Log.ICE_CANDIDATE);
				}catch(err){}
				
			}, function (e) {
				self.log.logMedia("Got error in onCadidate ", e)
			});
	}
	medias = {};
	sharingMedia;
	private stopOldMedias(callee, media) {
		//share 
		var oldMedia;
		var stream;
		if (media == MediaManagerService.MEDIA_SHARESCREEN || media == MediaManagerService.MEDIA_SHARESCREEN_NONE) {
			oldMedia = this.sharingMedia;
			this.sharingMedia = media;
		} else {
			if (!this.medias[callee]) {
				this.medias[callee] = {};
			}
			oldMedia = this.medias[callee]["media"];
			this.medias[callee]["media"] = media;

		}
		this.log.logMedia("Got old media " + oldMedia);
		if (oldMedia && oldMedia != media ) {
			
			this.log.logMedia("old media and media are different so will close the old one")
			try {
				var hash = this.getMediaHash(callee, oldMedia);
				if (this.peers[hash]){
					this.destroyPc(this.peers[hash]);
					//this.peers[hash].oniceconnectionstatechange=null;
					//this.peers[hash].close();
				delete this.peers[hash];

				this.log.logMedia("Peer " + hash + "closed ")
				}
			} catch (err) {
				this.log.logMedia("Error while destroying PC "+callee, err);
			}
			if (callee == this.ws.getMe()) {
				stream = this.streams[this.getMediaHash(callee, oldMedia)];
				this.log.logMedia("Will close stream for " + this.getMediaHash(callee, oldMedia));
				this.stopOutgoingStream(stream);
				if (oldMedia=='audio-snapshots' && this.snapshotsStream){
					this.stopOutgoingStream(this.snapshotsStream)
					this.layoutManager.stopSnapshots();
				}
				
			}
		}



	}
	
	notifyOnTalking(who, talks){
		for (let cb of this.onTalkingCallbacks){
			try{
				cb.onTalking(who, talks);
			}catch(error){
				this.log.log("got error in on talking");
			}
		}
	}
	notifyOnMediaReconnected(){
		for (let cb of this.onMediaCallbacks){
			try{
				cb.onMediaReconnected();
			}catch(error){
				this.log.log("got error in media reconnected ");
			}
		}
	}
	notifyOnMediaIncomingUpdated(who, connected){
		for (let cb of this.onMediaCallbacks){
			try{
				cb.onIncomingUpdated(who, connected);
			}catch(error){
				console.log("Got error ", error)
				this.log.log("got error in incoming updated ");
			}
		}
	}
	notifyOnMediaMediaUpdated(who, media){
		for (let cb of this.onMediaCallbacks){
			try{
				cb.onMediaUpdated(who, media);
			}catch(error){
				console.log("Got error ", error)
				this.log.log("got error in media updated ");
			}
		}
	}
	notifyOnMediaConnected(media){
		for (let cb of this.onMediaCallbacks){
			try{
				cb.onMediaConnected(media);
			}catch(error){
				console.log("Got error ", error)
				this.log.log("got error in media connected ");
			}
		}
	}
	onConnected(media, callee) {
		//if (media == MediaManagerService.MEDIA_SHARESCREEN || media==MediaManagerService.MEDIA_SHARESCREEN_NONE)return;
		
		this.log.logMedia("Connected " + callee + " and media " + media);
		this.stopOldMedias(callee, media);
		if (callee == this.ws.getMe()){
			this.notifyOnMediaIncomingUpdated(callee, true);
		}
			//this.roomManager.updatePeer(callee, "incoming", true);
		//this.roomManager.onPeerConnected(media, callee);
		this.notifyOnMediaMediaUpdated(callee, media);
		//this.roomManager.updatePeer(callee, "media", media);
		
		
		this.appRef.tick()
		
		if (media!="none"){
		//	this.getPeerStats(callee, media, callee == this.ws.getMe());
		
		
		
		$("#video-"+this.ws.getMe()).attr("playsinline", true);
		$("#video-"+callee).attr("playsinline", true);
		$("#video-"+this.ws.getMe()).attr("controls", true);
		$("#video-"+callee).attr("controls", true);
		var self = this;
		console.log("Will set controls");
		
		setTimeout(function(){
			
			$("#video-"+self.ws.getMe()).attr("controls", null);
			$("#video-"+callee).attr("controls", null);
			
		}, 100)
		try{
		//	this.getStats(media, callee);
			
		}catch(error){
			console.log(error);
		}
		
	}
		this.notifyOnMediaConnected(media);
	
	}
	
	private getPeerStat2(callee, media, sending){
		var pc = this.peers[this.getMediaHash(callee, media)];
		
		var self = this
		var last =0;
		var lastLost =0;
		var fn = function(result){
			pc = self.peers[self.getMediaHash(callee, media)];
			if (!pc) {
				console.log("PC cleared, stop getting stats");
				result.nomore(); return;
			}
		
			/*if (sending){
				console.log("Bytes sent ", result.video.bytesSent)
				console.log("Video bandwidth ", result.video.send.availableBandwidth);
				console.log("Audio bandwidth ", );
			}else{
				console.log("Bytes recieved ", result.video.bytesReceived)
				console.log("Video bandwidth ", result.video.recv.availableBandwidth);
				console.log("Audio bandwidth ", result.audio.recv.availableBandwidth);
			}
			console.log("Bandwidth ",result.bandwidth.speed) // bandwidth download speed (bytes per second)
			*/
			var audioPacketsLost;
			var videoPacketsLost;

			result.results.forEach(function(item) {
			//	console.log("ITEM IS ", item)
				if (item.type === 'ssrc' && item.transportId === 'Channel-audio-1') {
					var packetsLost = item.packetsLost;
					var packetsSent = item.packetsSent;
					var audioInputLevel = item.audioInputLevel;
					var trackId = item.googTrackId; // media stream track id
					var isAudio = item.mediaType === 'audio'; // audio or video
					var isSending = item.id.indexOf('_send') !== -1; // sender or receiver
		
					//console.log('SendRecv type', item.id.split('_send').pop());
					//console.log('MediaStream track type', item.mediaType);
					//console.log("Packets lost: "+packetsLost+": "+packetsSent);
					if (isAudio){
					audioPacketsLost = packetsLost
				//	console.log("Audio packets lost "+audioPacketsLost+" "+isSending+" "+callee+": "+media )	
				}else{
					videoPacketsLost = packetsLost
					console.log("Audio packets lost "+videoPacketsLost )
					}
					if (!isSending && self.ws.getMe()!=callee){
						
						console.log("packeds "+item.packetsLost+": "+(item.packetsLost-lastLost)+" and "+item.packetsReceived+":"+(item.packetsReceived-last))
						last = item.packetsReceived
						lastLost = item.packetsLost
					}
				}
			
			});
			if (sending){
				self.mediaParser.sendStat(media, audioPacketsLost, videoPacketsLost, result.bandwidth.speed, result.audio.send.availableBandwidth, result.video.send.availableBandwidth);
			}
		}
		console.log("WIILL try to get stats")
		if (webrtcDetectedBrowser=='firefox'){
		//	getStats(pc, pc.getTracks()[0], fn, 2 * 1000)
			var arr = pc.getSenders();
			if (arr && arr.length>0){
				setInterval(
					function(){
						arr[0].getStats().then(function(stats){
					
					for (var o of stats){
						if (o && (o.type !="candidatepair" && o.type != "localcandidate" && o.type != "remotecandidate"))
							console.log(stats[o]);
					}
						})
				},2000);
			}
		}else{
			getStats(pc, fn, 1000);
		}
	}
	
	getStats(media, hash) {
		var self = this;
		var pc = this.peers[this.getMediaHash(hash, media)];
		setInterval(function(){
				if (pc && (pc.iceConnectionState == "completed" || pc.iceConnectionState == "connected")){
			pc.getStats(null).then(stats => {
				var stat: UserStat = new UserStat();
				var videoStat, audioStat;
				var remoteCandidateId, localCandidateId;
				var videoTrackId, audioTrackId;
				var outgoing
				stats.forEach(r => {
					//console.log(r);
					if (r){
						if (r.type=='outbound-rtp'){
							outgoing = true;
							if (r.mediaType=="video"){
								videoStat = new VideoOutMediaStat(r.bytesSent, r.packetsSent, r.ssrc, r.trackId, r.firCount, r.framesEncoded, r.nackCount, r.pliCount, r.qpSum);
								videoTrackId = r.trackId;
							} else if (r.mediaType=='audio'){
								audioStat = new AudioOutMediaStat(r.bytesSent, r.packetsSent, r.ssrc, r.trackId);
								audioTrackId = r.trackId;
							}
						}
						if (r.type == "inbound-rtp"){
							outgoing = false;
							if (r.mediaType=="video"){
								videoStat = new VideoInMediaStat(r.bytesReceived, r.tractionLost, r.packetsLost, r.packetsReceived, r.firCount, r.framesDecoded, r.nackCount, r.pliCount, r.qpSum);
								videoTrackId = r.trackId;
							} else if (r.mediaType=='audio'){
								audioStat = new AudioInMediaStat(r.bytesReceived, r.tractionLost, r.packetsLost, r.packetsReceived, r.jitter);
								audioTrackId = r.trackId;
							}
						}
						if (r.type == "candidate-pair"){
							if (r.nominated){
								
								remoteCandidateId = r.remoteCandidateId;
								localCandidateId = r.localCandidateId;
								stat.bytesReceived = r.bytesReceived;
								stat.availableIncomingBitrate = r.availableIncomingBitrate
								stat.availableOutgoingBitrate = r.availableOutgoingBitrate
								stat.bytesSent = r.bytesSent
								stat.currentRoundTripTime = r.currentRoundTripTime
								stat.totalRoundTripTime = r.totalRoundTripTime
							}
						}
					}
				});
				if (!remoteCandidateId)return;
				
				stat.hash = hash;
				
				
				
				stats.forEach(r => {
					console.log(r);
					if (r){
						if (r.type=='local-candidate'){
							if (r.id == localCandidateId){
								stat.localIp = r.ip;
								stat.localPort = r.port;
								stat.localProto = r.protocol;
								stat.localType=r.candidateType;
							}
						}
						if (r.type=='remote-candidate'){
							if (r.id == remoteCandidateId){
								stat.remoteIp = r.ip;
								stat.remotePort = r.port;
								stat.remoteProto = r.protocol;
								stat.remoteType=r.candidateType;
							}
						}console.log(r)
						
						if (r.type == "track"){
							if (r.id == videoTrackId){
								if (outgoing){
									videoStat.frameHeight = r.frameHeight
									videoStat.frameWidth = r.frameWidth
									videoStat.framesSent = r.framesSent
								}else{
									videoStat.framesDropped = r.framesDropped
									videoStat.framesReceived = r.framesReceived
								}
							}
							if (r.id == audioTrackId){
								
									audioStat.audioLevel = r.audioLevel;
									audioStat.totalAudioEnergy = r.totalAudioEnergy;
									audioStat.totalSamplesDuration = r.totalSamplesDuration;

									if (!outgoing){
										audioStat.concealedSamples = r.concealedSamples
										audioStat.concealmentEvents = r.concealmentEvents
										audioStat.jitterBufferDelay = r.jitterBufferDelay
										audioStat.totalSamplesReceived = r.totalSamplesReceived;
									}
							}
						}
					}});

					if (outgoing){
						stat.audioOut = audioStat;
						stat.videoOut = videoStat;
					}else{
						stat.audioIn = audioStat;
						stat.videoIn = videoStat;
					}
					console.log(stat);
					self.http.post("http://localhost:8084/report2/"+self.ws.getMe(), stat)
      .subscribe(data => {
          console.log("Fine")
      });
					
	
			});
		}
		}, 1000);
	
	}

	/*private getPeerStats(callee, media, sending){
		var pc = this.peers[this.getMediaHash(callee, media)];
		
		var self = this
		var last =0;
		var lastLost =0;
		
		pc = self.peers[self.getMediaHash(callee, media)];
		var selector = null;
		console.log("Will get stats");
		if (webrtcDetectedBrowser=='safari'){
			selector = pc.getLocalStreams()[0].getTracks()[0];
			console.log("Selector for safari is ", selector)
		}
			setInterval(()=>{
				console.log("Will call stats")
				window.cur = pc
				this.getStats(pc, selector).then(function(stats){
					
					
			
					function p(v, k, m){
						
						if (typeof v["mediaType"] !== 'undefined' && (typeof v["bytesSent"] !== 'undefined' || typeof v["bytesReceived"] !== 'undefined')){
							console.log("Got the right type of metric ", v);
							if (typeof v["bytesSent"]){
								console.log("Sending bytes", v["bytesSent"]);
							}else{

							}
						}
					}
					if (webrtcDetectedBrowser=='chrome'){
						for (var i in stats){
							p(stats[i], i, stats);
						}
					}else
					stats.forEach(p);
					
				}).catch(function(err){
					console.log("Got error ", err);
				})
			}, 1000);
		
		
	}*/
	
	onIncomingUpdated(callee, media) {

		switch (media) {
			case "none": 
			this.notifyOnTalking(callee, false);
			//this.roomManager.updatePeer(callee, "talking", false);
			case "both":
			case "audio":
			case "video":
				this.notifyOnMediaIncomingUpdated(callee, media != "none");
				//this.roomManager.updatePeer(callee, "incoming", media != "none");
				this.log.logMedia("Callee receives " + media + " from me");
				break;
			case MediaManagerService.MEDIA_SHARESCREEN:
			case MediaManagerService.MEDIA_SHARESCREEN_NONE:
				this.log.logMedia("Callee receives " + media + " from me");
				break;

		}
	}

	private getStat(pc, id) {
		try {
			if (!pc.getRemoteStreams()[0]) {
				return
			}
			var selector = pc.getRemoteStreams()[0].getAudioTracks()[0];
			var self = this
			if (selector)
				pc.getStats(selector, function (report) {
					var results = report;
					for (var rr in results) {
						var c = results[rr]
						var v = c.audioOutputLevel / 32767;
						self.notifyOnTalking(self.callees[id], v > 0.005);
						//self.roomManager.updatePeer(, "talking", v > 0.005)
						//	self.peerTalking(id, v > 0.005);
						continue;
					}
				}, function (e) {
					console.log(e);
				})
		} catch (error) {

		}
	}
	registerForOnPeerTalking() {

		var self = this;
		setInterval(function () {
			for (var id in self.peers) {
				var p = self.peers[id];

				if (p)
					self.getStat(p, id);
			}
		}, 1000);

	}
	onExited(who) {
		this.log.logMedia("Exited " + who + ",  will try to release eventual peer connections")
		
		if (!this.mediaHashes[who]) return;
		for (let m of this.mediaHashes[who]) {
			this.log.logMedia("Peer " + who + " has " + m + " so will close it ");
			try {
				this.destroyPc(this.peers[m]);
				
			} catch (error) {
				this.log.logMedia("Error while destroying PC ", error);
			}
			try {
				delete this.peers[m];
			} catch (err) {

			}
		}
	}
	mediaReconnected() {
		
		this.notifyOnMediaReconnected();
		//this.roomManager.onDisconnected();
		this.onDisconnected();
		//this.roomManager.onConnected();
	}
	onDisconnected(expected = true) {
		this.log.logMedia("WS has closed");
		if (expected) {
			for (let s in this.streams)
				this.stopOutgoingStream(this.streams[s]);
			for (let p in this.peers) {
				try {
					this.log.logMedia("Closing " + p);
					this.destroyPc(this.peers[p]);
					

				} catch (err) {

				}
				try {
					delete this.peers[p];
				} catch (err) { }
			}
		} else {
			this.log.logMedia("Unexpected disconnection");

		}
	}
	public stopOutgoingStream(stream) {
		if (stream) {
			try {
				for (let i = 0; i < stream.getTracks().length; i++) {
					stream.getTracks()[i].stop();
				}
				stream = null;
			} catch (error) {
				this.log.logMedia("Could not stop medias in stopOutgoingStream ", error);
			}

		}
	}
	shareScreenOnMessageCallback(event) {
		if (event.origin != window.location.origin) {
			return;
		}
		this.log.logMedia("Onmessage callback ", event.data);
		if (event.data == 'rtcmulticonnection-extension-loaded') {
			this.hasShareScreenPluginInstalled = true;
			this.getSourceId();
		}
		if (event.data.sourceId) {
			//if (this.wbService.isDemo()) return;
			this.startSharing(event.data.sourceId);
		}
	}
	registeredForOnMessage = false;
	shareScreen(cb) {
		if (this.sharingStream) {
			this.onShareScreenStreamEnded();
			return;
		}
		var ready = false;
		var _this = this;
		if (!this.registeredForOnMessage) {
			window.addEventListener('message', this.shareScreenOnMessageCallback.bind(this));
			this.registeredForOnMessage = true;
		}
		window.postMessage('are-you-there', '*');
		setTimeout(function () {
			if (!_this.hasShareScreenPluginInstalled) {
				cb(false);
			}
		}, 1000);

	}
	hasShareScreenPluginInstalled = false;
	startSharing(sourceId) {
		console.log("Will start sharing ", sourceId);
		var _this = this;
		var screen_constraints = {
			mandatory: {
				chromeMediaSource: "desktop",
				maxWidth: 1920,
				maxHeight: 1080,
				minAspectRatio: 1.77,
				chromeMediaSourceId: sourceId
			},
			optional: []
		};
		var session = {
			audio: false,
			video: screen_constraints
		};

		// now invoking native getUserMedia API
		navigator.webkitGetUserMedia(session, function (stream) {
			console.log("Got shared stream ", stream);
			stream.getVideoTracks()[0].onended = function () {
				console.log("User has stopped sharing");
				_this.onShareScreenStreamEnded();
			}
			_this.onShareScreenStream(stream);
		}, function (e) {
			console.log("On error in getting share screen ", e);
		});
	}
	sharingStream;
	onShareScreenStream(stream) {
		this.sharingStream = stream;
		console.log("Got share screen ", stream);
		//var id = this.getUserId(this.wsService.userHash, true);
		this.requestShareScreen();

	}

	sendVideoSnapshot(snapshot:string) {
		this.mediaParser.sendSnapshot(snapshot);
	}

	getSourceId() {

		window.postMessage('get-sourceId', '*');
	}
	onShareScreenStreamEnded() {
		console.log("Share screen ended");
		this.stopOutgoingStream(this.sharingStream);
		this.sharingStream = null;
		this.changeMedia(this.ws.getMe(), MediaManagerService.MEDIA_SHARESCREEN_NONE);
	}
	alreadyConnected(callee, media) {
		if (media == MediaManagerService.MEDIA_SHARESCREEN) {
			this.stopOutgoingStream(this.sharingStream);
		}
		this.notifyOnMediaMediaUpdated(callee, media);
		//this.roomManager.updatePeer(callee, "media", media);
 	}
 noMoreStreams(){
//	 this.wbService.noMoreStreams();
 }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/media/media-manager.service.ts